function validateJSON(data) {
    try {
      if(typeof data == "string"){
        return JSON.parse(data);
      }else{
        return data;
      }
    } catch (error) {
      console.error('Invalid JSON:', error);
      return {};
    }
  }

export default validateJSON;